"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var JourneyListContext_1 = require("./JourneyListContext");
var useJourneyListContext = function () {
    return react_1.useContext(JourneyListContext_1.default);
};
exports.default = useJourneyListContext;
